import * as React from 'react';
const FooterBanner = () => (
  <div
    style={{
      alignSelf: 'center',
      marginBottom: 'var(--single)',
      marginTop: 'var(--single)',
      maxWidth: '100%',
      textAlign: 'center',
    }}>
    <div data-fuse="22969287385" style={{ minHeight: '600px' }}></div>
  </div>
);
export default FooterBanner;
